import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cta-content" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group checkbox-group" }
const _hoisted_5 = { class: "checkbox-label" }

import { ref } from 'vue'
import { motion } from "motion-v"
import GradientButton from "@/components/GradientButton.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CallToActionSection',
  setup(__props) {

const form = ref({
  name: '',
  contact: '',
  privacyConsent: false
})

const handleSubmit = (event: Event) => {
  if (!form.value.privacyConsent) {
    event.preventDefault()
    alert('Bitte stimme der Datenverarbeitung zu, um fortzufahren.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(motion).div, {
    class: "cta-section",
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { delay: 0.4, duration: 0.6 },
    inViewOptions: { once: true }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "cta-text" }, [
          _createElementVNode("h3", { class: "cta-title" }, "Brauchst du Unterstützung bei einem Laravel oder Vue Projekt? ☕"),
          _createElementVNode("p", { class: "cta-subtitle" }, [
            _createTextVNode(" Lass uns kurz quatschen. Schreib mir einfach, wo es bei euch aktuell brennt und wir schauen, ob ich euch weiterhelfen kann."),
            _createElementVNode("br"),
            _createElementVNode("br"),
            _createTextVNode(" Hinterlasse mir einfach deine Kontaktdaten – ich melde mich bei dir. ")
          ])
        ], -1)),
        _createElementVNode("form", {
          name: "callback-consulting",
          class: "callback-form",
          method: "POST",
          "data-netlify": "true",
          action: "/",
          "netlify-honeypot": "bot-field",
          onSubmit: handleSubmit
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("input", {
            type: "hidden",
            name: "form-name",
            value: "callback-consulting"
          }, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("input", {
            name: "bot-field",
            style: {"display":"none"}
          }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { for: "callback-name" }, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "callback-name",
              name: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, form.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "callback-contact" }, "Telefonnummer / E-Mail Adresse", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "callback-contact",
              name: "contact",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.contact) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, form.value.contact]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                name: "privacy-consent",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.privacyConsent) = $event)),
                required: ""
              }, null, 512), [
                [_vModelCheckbox, form.value.privacyConsent]
              ]),
              _cache[6] || (_cache[6] = _createTextVNode(" Ich stimme der Verarbeitung meiner Daten gemäß der ", -1)),
              _createVNode(_component_router_link, {
                to: "/datenschutz",
                class: "privacy-link"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Datenschutzerklärung", -1)
                ])),
                _: 1,
                __: [5]
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" zu. ", -1))
            ])
          ]),
          _createVNode(GradientButton, {
            type: "submit",
            disabled: !form.value.privacyConsent
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Kostenloses Beratungsgespräch anfragen ", -1)
            ])),
            _: 1,
            __: [8]
          }, 8, ["disabled"])
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

})